module.exports = __webpack_public_path__ + "media/images/collaborate-8d0407f44b244b762db5b783f51909ef.svg";